import { LABELS } from '@/constants/common/message.constants'
import { type MonthlyTourReportExEntity } from '@/libs/api'

/**
 * 月次支払レポートステータス
 * */
export type MonthlyTourReportStatus = MonthlyTourReportExEntity['status']

export const MONTHLY_TOUR_REPORT_STATUS = {
  /** パートナー作成中 */
  PARTNER_CONFIRM_PENDING: 'PARTNER_CONFIRM_PENDING',
  /** パートナー再確認 */
  PARTNER_RECONFIRM_PENDING: 'PARTNER_RECONFIRM_PENDING',
  /** 確認待ち */
  DC_CONFIRM_PENDING: 'DC_CONFIRM_PENDING',
  /** センター再確認 */
  DC_RECONFIRM_PENDING: 'DC_RECONFIRM_PENDING',
  /** センター最終確認待ち */
  DC_FINAL_CONFIRM_PENDING: 'DC_FINAL_CONFIRM_PENDING',
  /** 確認済 */
  CONFIRMED: 'CONFIRMED'
} as const satisfies Record<MonthlyTourReportStatus, MonthlyTourReportStatus>

export const MONTHLY_TOUR_REPORT_STATUS_LABEL = {
  [MONTHLY_TOUR_REPORT_STATUS.PARTNER_CONFIRM_PENDING]:
    LABELS.PARTNER_CONFIRMING,
  [MONTHLY_TOUR_REPORT_STATUS.PARTNER_RECONFIRM_PENDING]:
    LABELS.PARTNER_RECONFIRMING,
  [MONTHLY_TOUR_REPORT_STATUS.DC_CONFIRM_PENDING]: LABELS.DC_CONFIRMING,
  [MONTHLY_TOUR_REPORT_STATUS.DC_RECONFIRM_PENDING]: LABELS.DC_RECONFIRMING,
  [MONTHLY_TOUR_REPORT_STATUS.DC_FINAL_CONFIRM_PENDING]:
    LABELS.DC_FINAL_CONFIRMING,
  [MONTHLY_TOUR_REPORT_STATUS.CONFIRMED]: LABELS.DC_CONFIRMED
}
